import React from 'react';
import { motion } from 'framer-motion';

const Problem = () => {
  return (
    <section className="py-20 bg-brand-gray border-y border-white/5">
      <div className="container mx-auto px-6 max-w-4xl text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-8">
            You Keep Fighting About <span className="text-brand-yellow">Nothing</span>
          </h2>
          
          <div className="space-y-6 text-gray-300 text-lg leading-relaxed text-left md:text-center">
            <p>
              You said one thing. They heard something else entirely.
              Now you're in a three-hour fight about "I'm fine" or "do what you want"—and neither of you understands why.
            </p>
            <p className="font-medium text-white">
              The real problem: You're speaking different languages.
            </p>
            <div className="grid md:grid-cols-2 gap-6 my-8 text-left">
              <div className="bg-brand-black p-6 rounded-lg border border-white/10">
                <h3 className="text-brand-yellow font-bold mb-2">He compresses emotion</h3>
                <p>Into "nothing's wrong" when everything is wrong.</p>
              </div>
              <div className="bg-brand-black p-6 rounded-lg border border-white/10">
                <h3 className="text-brand-yellow font-bold mb-2">She embeds requests</h3>
                <p>In "whatever you think" expecting you to know.</p>
              </div>
            </div>
            <p>
              Both feel unheard. Both feel attacked. Both are wrong about what the other meant.
            </p>
          </div>

          <div className="mt-12 p-8 bg-red-500/10 border border-red-500/20 rounded-xl">
            <h3 className="text-xl font-bold text-white mb-4">The Cost of Misunderstanding:</h3>
            <ul className="text-left space-y-3 text-gray-300 mx-auto max-w-lg">
              <li className="flex items-start gap-3">
                <span className="text-red-500">✗</span> Nights spent analyzing texts instead of sleeping
              </li>
              <li className="flex items-start gap-3">
                <span className="text-red-500">✗</span> Fights that start over nothing and end everything
              </li>
              <li className="flex items-start gap-3">
                <span className="text-red-500">✗</span> Relationships that die from misunderstanding, not lack of love
              </li>
            </ul>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Problem;